import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { forwardRef } from "react";
import MaterialTable from "material-table";
import Button from "@material-ui/core/Button";
import { makeStyles, MuiThemeProvider } from "@material-ui/core/styles";
import {Dialog, DialogContent, Grid} from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import Slide from "@material-ui/core/Slide";
import CircularProgress from "@material-ui/core/CircularProgress";
import Radio from "@material-ui/core/Radio";
import TablePagination from "@material-ui/core/TablePagination";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import Box from "@material-ui/core/Box";
import { useSnackbar } from "notistack";

import { color_palette } from "../../theme/theme";
// import { clients_list, Customer_search } from "../../DAL/country/clients";
import { default_image } from "../../assets";
import { s3baseUrl } from "../../config/config";
import { transaction_list } from "../../DAL/transaction/transaction";
import moment from "moment";

//-------dialog-transition
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const useStyles = makeStyles({
  hed: {
    fontWeight: "bold",
  },
  clmwdth: {
    width: "10px",
  },
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  btnadd: {
    float: "left",
    color: "white",
    fontSize: "15px",
  },
  mnu: {
    cursor: "pointer",
  },
});

function Transactions(props) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const tableRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [selectedrow, setrowdata] = React.useState([]);
  const [isuser, setusers] = React.useState(true);
  const [isdata, setisdata] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [totalPage, setTotalpage] = React.useState();
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [search, setSearch] = React.useState("");
  const [openFilter, setOpenFilter] = React.useState(false);
  const [to_date, setTo_Date] = React.useState("");
  const [from_date, setFrom_Date] = React.useState("");
  const [columns, setColumns] = React.useState([
    {
      title: <span className={classes.hed}>#</span>,
      width: 150,
      render: (rowData) => <>{rowData.tableData.id + 1}</>,
    },
    {
      title: <span className={classes.hed}> Order no.</span>,
      render: (rowData) => (
        <>
          <div style={{ minWidth: 100 }}>
            {rowData.order[0]?.order_id ? rowData.order[0]?.order_id : "---"}
          </div>
        </>
      ),
      sorting: false,
    },
    {
      title: <span className={classes.hed}> Payment For</span>,
     field: "payment_for",
      // render: (rowData) => (
      //   <>
      //     <div style={{ minWidth: 100 }}>
      //       {rowData.payment_for}
      //     </div>
      //   </>
      // ),
      sorting: false,
    },
    {
      title: <span className={classes.hed}> Transaction ID</span>,
     field: "stripe_charge_id",
      // render: (rowData) => (
      //   <>
      //     <div style={{ minWidth: 100 }}>
      //       {rowData.stripe_charge_id}
      //     </div>
      //   </>
      // ),
      sorting: false,
    },
    {
        title: <span className={classes.hed}> Customer Name</span>,
      //  field: "contact_number",
        render: (rowData) => (
          <>
            <div style={{ minWidth: 100 }}>
              {rowData.user_detail?.name}
            </div>
          </>
        ),
        sorting: false,
      },
      {
        title: <span className={classes.hed}> Customer Email</span>,
      //  field: "contact_number",
        render: (rowData) => (
          <>
            <div style={{ minWidth: 100 }}>
              {rowData.profile?.email}
            </div>
          </>
        ),
        sorting: false,
      },
      {
        title: <span className={classes.hed}> Customer Phone Number</span>,
      //  field: "contact_number",
        render: (rowData) => (
          <>
            <div style={{ minWidth: 100 }}>
              {rowData.profile?.phone_number}
            </div>
          </>
        ),
        sorting: false,
      },
    {
      title: <span className={classes.hed}> Products</span>,
    //  field: "contact_number",
      render: (rowData) => (
        <>
          <div style={{ minWidth: 100 }}>
            {rowData.product?.length}
            {/* {rowData.product[0]?.name ? rowData.product[0]?.name : "---"} */}
          </div>
        </>
      ),
      sorting: false,
    },
    {
      title: <span className={classes.hed}> Transaction Date</span>,
    //  field: "contact_number",
      render: (rowData) => (
        <>
          <div style={{ minWidth: 100 }}>
            {moment(rowData.createdAt).format("DD MMM YYYY hh:mm:sa")}
          </div>
        </>
      ),
      sorting: false,
    },
    {
      title: <span className={classes.hed}> Sub Total Amount</span>,
    //  field: "amount",
      render: (rowData) => (
        <>
          <div style={{ minWidth: 100 }}>
            {rowData.sub_amount + " " + rowData.currency[0]?.currency}
          </div>
        </>
      ),
      sorting: false,
    },
    {
      title: <span className={classes.hed}> Delivery Charges</span>,
    //  field: "amount",
      render: (rowData) => (
        <>
          <div style={{ minWidth: 100 }}>
            {rowData.delivery_charges + " " + rowData.currency[0]?.currency}
          </div>
        </>
      ),
      sorting: false,
    },
    {
      title: <span className={classes.hed}> VAT </span>,
    //  field: "amount",
      render: (rowData) => (
        <>
          <div style={{ minWidth: 100 }}>
            {rowData.vat_amount + " " + rowData.currency[0]?.currency}
          </div>
        </>
      ),
      sorting: false,
    },
    {
      title: <span className={classes.hed}> Discount </span>,
    //  field: "amount",
      render: (rowData) => (
        <>
          <div style={{ minWidth: 100 }}>
            {rowData?.discount ? rowData?.discount.toFixed(2) + " " + rowData.currency[0]?.currency : "N/A"}
          </div>
        </>
      ),
      sorting: false,
    },
    {
      title: <span className={classes.hed}> Total Amount</span>,
    //  field: "amount",
      render: (rowData) => (
        <>
          <div style={{ minWidth: 100 }}>
            {rowData.total_amount + " " + rowData.currency[0]?.currency}
          </div>
        </>
      ),
      sorting: false,
    },
    {
      title: <span className={classes.hed}> Transaction Status</span>,
     field: "transaction_status",
      // render: (rowData) => (
      //   <>
      //     <div style={{ minWidth: 100 }}>
      //       {rowData.transaction_status}
      //     </div>
      //   </>
      // ),
      sorting: false,
    },
    // {
    //   title: <span className={classes.hed}> Clients </span>,
    // //  field: "post_code",
    // render: (rowData) => (
    //   <>
    //     <div style={{ minWidth: 100 }}>
    //       <Button color="primary" variant="outlined" onClick={()=> props.history.push(`/designers/client_detail/${rowData._id}`)} >
    //           Details
    //       </Button>
    //     </div>
    //   </>
    // ),
    //   sorting: false,
    // },
    // {
    //   title: <span className={classes.hed}>Status</span>,

    //   render: (rowData) =>
    //     rowData.status ? (
    //       <>
    //         <div style={{ minWidth: 100 }}>
    //           <Radio
    //             checked
    //             style={{ color: color_palette.primary, marginLeft: -15 }}
    //           />
    //           Active
    //         </div>
    //       </>
    //     ) : (
    //       <>
    //         <div style={{ minWidth: 100 }}>
    //           <Radio
    //             checked={true}
    //             disabled
    //             color={color_palette.primary}
    //             style={{ marginLeft: -15 }}
    //           />
    //           Inactive
    //         </div>
    //       </>
    //     ),
    //   sorting: false,
    // },
  ]);

  const hanldeSearchChange = async (e) => {
    setSearch(e.target.value);
    setData([]);
    setisdata(false);
    // const data_search = await Customer_search(
    //   page,
    //   rowsPerPage,
    //   e.target.value
    // );
    // console.log(data_search, "DATA SEARCH");
    // if (data_search.code == 200) {
    //   if (data_search.data.customer.length != 0) {
    //     setData(data_search.data.customer);
    //     setTotalpage(data_search.data.total_pages);
    //     setPage(0);
    //   }
    //   setisdata(true);
    // }
  };
  const Addcategory = () => {
    props.history.push("/Addcategory");
  };
  const handleClickOpen = (rowdata) => {
    setrowdata(rowdata);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOpenFilter(false);
  };
  const handleChangePage = (event, newPage) => {
    setData([]);
    setisdata(false);
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    tableRef.current.dataManager.changePageSize(parseInt(event.target.value));
    setData([]);
    setisdata(false);
    setRowsPerPage(parseInt(event.target.value));
  };
  const deleteuser = async () => {
    // setOpen(false);
    // setData([]);
    // setisdata(false);
    // const delete_category_resp = await delete_category(selectedrow._id);
    // await get_category(page);
  };

  const handleApplyFilter = async ()=> {
    // const postData ={
    //   to_date,
    //   from_date,
    //   order_option,
    // }
    setData([]);
    setisdata(true);
    // setusers(true);
    handleClose();
    const transaction_list_resp = await transaction_list(to_date, from_date);
    if(transaction_list_resp.code === 200){
      console.log(transaction_list_resp, "orders_list_resp");
      setTotalpage(transaction_list_resp.transactions.length);
      setData(transaction_list_resp.transactions);
      handleClose()
      setusers(false);
      setisdata(false);
    }else{
      enqueueSnackbar(transaction_list_resp.message, { variant: "error" });
    }
  }

  const handleResetFilter = async () => {
    handleClose();
    setData([]);
    setisdata(true);
    
    // setusers(true);
    const transaction_list_resp = await transaction_list();
    if(transaction_list_resp.code === 200){
      console.log(transaction_list_resp, "orders_list_resp");
      setTotalpage(transaction_list_resp.transactions.length);
      setData(transaction_list_resp.transactions);
      setusers(false);
      handleClose()
      setisdata(false);
    }
    // setisdata(true);
  }
  const get_Transaction = async () => {
    const transaction_list_resp = await transaction_list(to_date, from_date);
    if(transaction_list_resp.code === 200){
      console.log(transaction_list_resp, "orders_list_resp");
      setTotalpage(transaction_list_resp.transactions.length);
      setData(transaction_list_resp.transactions);
      setusers(false);
      setisdata(false);
    }
  };
  useEffect(() => {
    get_Transaction(page, rowsPerPage);
  }, [rowsPerPage, page]);
  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  return (
    <>
      {isuser == true ? (
        <CircularProgress style={{ marginTop: "15%", marginLeft: "45%" }} />
      ) : (
        <MuiThemeProvider>
           <Button
            onClick={()=> setOpenFilter(true)}
            className={classes.btnadd}
            variant="contained"
            color="primary"
          >
            Filter
          </Button>
          <MaterialTable
            tableRef={tableRef}
            onSearchChange={(e) => console.log("search changed: " + e)}
            style={{ marginTop: "50px" }}
            title="Transactions"
            icons={tableIcons}
            columns={columns.map((c) => ({ ...c, tableData: undefined }))}
            // components={{
            //   Pagination: (props) => (
            //     <TablePagination
            //       component="div"
            //       count={totalPage}
            //       rowsPerPageOptions={[10, 20, 30, 40]}
            //       page={page}
            //       onChangePage={handleChangePage}
            //       rowsPerPage={rowsPerPage}
            //       onChangeRowsPerPage={handleChangeRowsPerPage}
            //     />
            //   ),
            //   Toolbar: (props) => (
            //     <div>
            //       <Box display="flex" p={1}>
            //         <Box p={1} flexGrow={1}>
            //           <h3>Transactions</h3>
            //         </Box>
            //         <Box p={1}>
            //           <TextField
            //             id="input-with-icon-textfield"
            //             value={search}
            //             focused
            //             autoFocus={true}
            //             onChange={hanldeSearchChange}
            //             placeholder="Search"
            //             InputProps={{
            //               startAdornment: (
            //                 <InputAdornment
            //                   position="start"
            //                   style={{ float: "right" }}
            //                 >
            //                   <SearchIcon />
            //                 </InputAdornment>
            //               ),
            //             }}
            //           />
            //         </Box>
            //       </Box>
            //     </div>
            //   ),
            // }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <div style={{ padding: 20 }}>
                    {isdata == true ? (
                      <CircularProgress />
                    ) : (
                      <h5>No data found to display</h5>
                    )}
                  </div>
                ),
              },
            }}
            data={data}
            options={{
              actionsColumnIndex: -1,
              search: true,
              // pageSize: rowsPerPage,
              pageSize: 50,
              pageSizeOptions: [50,100,150,200,250],
              emptyRowsWhenPaging: false,
              headerStyle: {
                backgroundColor: "#007044",
                color: color_palette.secondary,
                fontWeight: "bold",
              },
            }}
          />

<Dialog
            open={openFilter}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">Filter your Data</DialogTitle>
            <DialogContent>
            <Grid container spacing={3} >

            <Grid item xs={12} style={{paddingTop:0,paddingBottom:0}}>
               <TextField
              id="outlined-multiline-static"
              label="From Date"
              className={classes.textField}
              margin="normal"
              variant="outlined"
              fullWidth
              type="date"
              autoFocus
              
              InputLabelProps={{
                shrink: true,
              }}
           value={from_date}
           onChange={(e)=> setFrom_Date(e.target.value)}
           name="name"
 
         />
          </Grid>
          
          <Grid item xs={12} style={{paddingTop:0,paddingBottom:0}}>
               <TextField
          id="outlined-multiline-static"
          label="To Date"
          className={classes.textField}
          margin="normal"
          variant="outlined"
          fullWidth
          type="date"
          autoFocus
          InputLabelProps={{
            shrink: true,
          }}
           value={to_date}
           onChange={(e)=> setTo_Date(e.target.value)}
           name="name"
 
         />
          </Grid>
          
 
          {/* <Grid item xs={12} style={{paddingTop:0,paddingBottom:0, marginTop: 10}}>
          <FormControl variant="outlined" className={classes.formControl} fullWidth autoFocus>
        <InputLabel htmlFor="outlined-age-native-simple">Select Order Option</InputLabel>
        <Select
          native
          value={order_option}
          onChange={(e)=> setOrder_Option(e.target.value)}
          autoFocus
          label="Select Order Option"
          inputProps={{
            name: 'Select Order Option',
            id: 'outlined-Select-Order-Option-native-simple',
          }}
        >
          <option aria-label="None" value="" />
          <option value={1}>Delivery Product to me</option>
          <option value={2}>Pickup from Suppliers</option>
          <option value={3}>Donate Product and get extra tokens </option>
          <option value={4}>Donate Product and get extra tickets</option>
          
        </Select>
      </FormControl>
          </Grid>

          <Grid item xs={12} style={{paddingTop:0,paddingBottom:0, marginTop: 20}}>
          <FormControl variant="outlined" className={classes.formControl} fullWidth autoFocus>
        <InputLabel htmlFor="outlined-Status-native-simple">Select Order Status</InputLabel>
        <Select
          native
          value={filterOrderStatus}
          onChange={(e)=> setFilterOrderStatus(e.target.value)}
          autoFocus
          label="Select Order Status"
          inputProps={{
            name: 'Select Status Option',
            id: 'outlined-Select-Status-Option-native-simple',
          }}
        >
          <option aria-label="None" value="" />
          <option value="pending">Pending</option>
          <option value="delivered">Delivered</option>
          <option value="donated">Donated</option>
          <option value="cancelled">Cancelled</option>
          
        </Select>
      </FormControl>
          </Grid>

          <Grid item xs={12} style={{paddingTop:0,paddingBottom:0, marginTop: 20}}>
          <FormControl variant="outlined" className={classes.formControl} fullWidth autoFocus>
        <InputLabel htmlFor="outlined-Product-native-simple">Select Product</InputLabel>
        <Select
          native
          value={product_id}
          onChange={(e)=> setProduct_Id(e.target.value)}
          autoFocus
          label="Select Product"
          inputProps={{
            name: 'Select Product',
            id: 'outlined-Select-Product-native-simple',
          }}
        >
          <option aria-label="None" value="" />
          {productData.map((x,i)=>(
            <option value={x._id}>{x.name}</option>
          ))}
          
          
        </Select>
      </FormControl>
          </Grid>


          <Grid item xs={12} style={{paddingTop:0,paddingBottom:0, marginTop: 20}}>
          <FormControl variant="outlined" className={classes.formControl} fullWidth autoFocus>
        <InputLabel htmlFor="outlined-Prize-native-simple">Select Prize</InputLabel>
        <Select
          native
          value={prize_id}
          onChange={(e)=> setPrize_Id(e.target.value)}
          autoFocus
          label="Select Prize"
          inputProps={{
            name: 'Select Prize',
            id: 'outlined-Select-Prize-native-simple',
          }}
        >
          <option aria-label="None" value="" />
          {productData.map((x,i)=>(
            <>
            {x.prize_id?.active == true && <option value={x.prize_id?._id}>{x.prize_id?.name}</option>}
            </>
          ))}
          
        </Select>
      </FormControl>
          </Grid> */}
 
        
          </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button onClick={handleResetFilter}>
                Reset
              </Button>
              <Button onClick={handleApplyFilter} color="primary">
                Apply
              </Button>
            </DialogActions>
          </Dialog>


          <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{`Are you sure you want to Delete ${selectedrow.title}`}</DialogTitle>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Disagree
              </Button>
              <Button onClick={deleteuser} color="primary">
                Agree
              </Button>
            </DialogActions>
          </Dialog>
        </MuiThemeProvider>
      )}
    </>
  );
}
export default withRouter(Transactions);
